import { getNewsLetterFormDataFromApi } from 'application/connectors/cms/newsLetterConnector';

export const getNewsLetterForm = async (organisation: string): Promise<Models.NewsLetterSignUpFormResponse> => {
	return getNewsLetterFormDataFromApi(organisation);
};
